import { render, staticRenderFns } from "./modifyBank.vue?vue&type=template&id=654867a5"
import script from "./modifyBank.vue?vue&type=script&lang=js"
export * from "./modifyBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports